import React, { Suspense } from 'react';
import { Redirect, RouteProps, Switch } from 'react-router-dom';
import {
  NotFoundPath,
  ProductDetailPath,
  ShoppingCartPath,
  OrderRequestPath,
  MarketplaceCategoryPath,
  MarketplaceApprovalsPath,
  ViewOrderDetailPath,
  SoftwareRequestPagePath
} from 'utils/routes';
import { ProtectedRoute } from './AuthComponent';
import MarketplaceThemeProvider from 'containers/MarketplaceThemeProvider';
import LoadingScreen from 'components/LoadingScreen';
import { CheckRoutesConfigProps } from './routes';

const ShoppingCartPage = React.lazy(() =>
  import('pages/MarketPlacePage/ShoppingCartPage'),
);
const ApprovalPage = React.lazy(() =>
  import('pages/MarketPlacePage/ApprovalPage'),
);
const MarketplaceCategoryPage = React.lazy(() =>
  import('pages/MarketPlacePage/CategoryPage'),
);
const OrderRequestConfirmationPage = React.lazy(() =>
  import('pages/MarketPlacePage/OrderRequestConfirmationPage'),
);
const ProductDetailPage = React.lazy(() =>
  import('pages/MarketPlacePage/ProductDetailPage'),
);
const OrderRequestDetailPage = React.lazy(() =>
  import('pages/MarketPlacePage/OrderRequestDetailPage'),
);
const SoftwareRequestPage = React.lazy(() =>
  import('pages/MarketPlacePage/SoftwareRequestPage'),
);

export interface MarketplaceRouterProps {
  routes?: any;
  isOrderAllowed?: any;
  checkCustomRoutes?: CheckRoutesConfigProps;
};

export interface IMarketplaceRoutesProps extends RouteProps {
  name: string;
  enable?: boolean;
};

export const marketplaceRoutes: IMarketplaceRoutesProps[] = [
  {
    name: 'ShoppingCartPath',
    exact: true,
    path: ShoppingCartPath,
    component: ShoppingCartPage,
  },
  {
    name: 'OrderRequestPath',
    exact: true,
    path: OrderRequestPath,
    component: OrderRequestConfirmationPage,
  },
  {
    name: 'ProductDetailPathID',
    exact: true,
    path: `${ProductDetailPath}/:productId`,
    component: ProductDetailPage,
  },
  {
    name: 'MarketplaceApprovalsPath',
    exact: true,
    path: MarketplaceApprovalsPath,
    component: ApprovalPage,
  },
  {
    name: 'MarketplaceCategoryPath',
    exact: true,
    path: MarketplaceCategoryPath,
    component: MarketplaceCategoryPage,
  },
  {
    name: 'ViewOrderPathID',
    exact: true,
    path: ViewOrderDetailPath,
    component: OrderRequestDetailPage,
  },
  {
    name: 'MarketplaceApprovalsPathID',
    exact: true,
    path: `${MarketplaceApprovalsPath}/:id`,
    component: OrderRequestDetailPage,
  },
{
    name: 'SoftwareRequestPagePath',
    exact: true,
    path: SoftwareRequestPagePath,
    component: SoftwareRequestPage,
  },
];

const renderMarketplaceRoutes = (routes: [], isOrderAllowed: boolean) => {
  return routes?.map((route: any) => {
    if (isOrderAllowed || route?.path === OrderRequestPath) {
      return <ProtectedRoute key={String(route.path)} {...route} />;
    }
    return null;
  });
};

const MarketplaceRoutes = (props: MarketplaceRouterProps) => {
  const { routes, isOrderAllowed, checkCustomRoutes } = props;
  return (
    <MarketplaceThemeProvider>
      <Suspense fallback={<LoadingScreen />}>
        <Switch>
          {renderMarketplaceRoutes(routes, isOrderAllowed)}
          <Redirect to={checkCustomRoutes?.newPath || NotFoundPath} />
        </Switch>
      </Suspense>
    </MarketplaceThemeProvider>
  );
};

export default MarketplaceRoutes;
